import {$} from "../third-party-imports";
export function mollyMaidServicesList(){
     $('.services-list-screen').addClass('active');
    $('.about-home-screen').removeClass('active');
}